module.exports = __webpack_public_path__ + "static/media/banner2.469c57ea.png";